module.exports = __webpack_public_path__ + "images/file_icons_v2/pps-912f42be50a8f076a90f2d433037510c.svg";